import {ComplianceStandardTypeEnum} from 'src/api/ProactApiClient';

export const getTypeLabel = (
  type: ComplianceStandardTypeEnum | undefined
): string => {
  switch (type) {
    case ComplianceStandardTypeEnum.EPA:
      return 'EPA';
    case ComplianceStandardTypeEnum.OSHA:
      return 'OSHA';
    case ComplianceStandardTypeEnum.Custom:
      return 'Custom';
    default:
      return 'Unknown';
  }
};

export const getTypeColor = (
  type: ComplianceStandardTypeEnum | undefined
): string => {
  switch (type) {
    case ComplianceStandardTypeEnum.EPA:
      return 'green';
    case ComplianceStandardTypeEnum.OSHA:
      return 'blue';
    case ComplianceStandardTypeEnum.Custom:
      return 'violet';
    default:
      return 'gray';
  }
};

export const pageTitleDict = {
  singular: 'Compliance Standard',
  plural: 'Compliance Standards',
};

export const complianceStandardDocumentTitle = 'Compliance Standard';
